import type { EditorAction } from "../editor/reducers";
import type { Dispatch } from "react";
import { useState } from "react";
import { TableEditorStep } from "./TableEditorStep";
import { Input } from "@acdc2/ui/components/input";
import { AccessButton } from "@acdc2/ui/components/access-button";
import { useTranslation } from "react-i18next";
import { Icon } from "@mdi/react";
import {
  mdiTableColumn,
  mdiTableColumnPlusAfter,
  mdiTableColumnRemove,
} from "@mdi/js";

type Props = {
  dispatch: Dispatch<EditorAction>;
  isSelectionFullWidth: boolean;
  isSelectionFullHeight: boolean;
  isSelectionSpanningSingleCol: boolean;
};

export function TableEditorStep2({
  dispatch,
  isSelectionFullHeight,
  isSelectionFullWidth,
  isSelectionSpanningSingleCol,
}: Props) {
  const { t } = useTranslation();
  const [divisor, setDivisor] = useState(2);

  return (
    <TableEditorStep
      value="step2"
      iconPath={mdiTableColumn}
      title={t("TableEditorStep2.title")}
      description={t("TableEditorStep2.description")}
    >
      <div className="flex gap-2">
        <Input
          type="number"
          placeholder={t("TableEditorStep2.inputs.divider.placeholder")}
          value={divisor}
          onChange={(e) => setDivisor(parseInt(e.target.value))}
        />
        <AccessButton
          type="button"
          variant="outline"
          onClick={() => dispatch({ type: "divideTableCol", divisor })}
          disabled={!isSelectionFullHeight || !isSelectionSpanningSingleCol}
        >
          <Icon path={mdiTableColumnPlusAfter} size="1rem" />
          {t("TableEditorStep2.inputs.split.label")}
        </AccessButton>
      </div>
      <AccessButton
        type="button"
        variant="outline"
        onClick={() => dispatch({ type: "deleteTableCols" })}
        disabled={!isSelectionFullHeight || isSelectionFullWidth}
      >
        <Icon path={mdiTableColumnRemove} size="1rem" />
        {t("TableEditorStep2.inputs.delete.label")}
      </AccessButton>
    </TableEditorStep>
  );
}
